import type { z } from 'zod';

import type { NotesCategorySchema } from './schemas';

type NotesCategoryField = keyof z.infer<typeof NotesCategorySchema>;

const listAttributes = [
  'id',
  'subject',
  'code',
  'label',
  'shortLabel',
  'notes',
] as const satisfies readonly NotesCategoryField[];

const getAttributes = [...listAttributes] as const satisfies readonly NotesCategoryField[];

const updateAttributes = [
  'label',
  'shortLabel',
  'notes',
] as const satisfies readonly NotesCategoryField[];

export const NotesCategoryAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
};
